import type { MarketCode } from '@sharpr/types';

/** Pitcher position tokens used across the app. NBA positions never collide. */
const PITCHER_POSITIONS = new Set(['P', 'SP', 'RP']);

function isPitcherPosition(position: string | null | undefined): boolean {
  return !!position && PITCHER_POSITIONS.has(position);
}

export function isPitcherMarket(market: string | null | undefined): boolean {
  return !!market && market.startsWith('pitcher_');
}

/**
 * Resolves a player's role for THIS context: position takes precedence (a starter is a
 * pitcher regardless of which market is in focus), but two-way / unlabeled-position rows
 * fall back to the market code (`pitcher_*` markets imply pitcher role).
 */
export function resolvePositionType(
  position: string | null | undefined,
  market: MarketCode | string | null | undefined = undefined,
): 'pitcher' | 'batter' {
  return isPitcherPosition(position) || isPitcherMarket(market) ? 'pitcher' : 'batter';
}
